import CardSystem from '../CardSystem';
import CardAnimationTask from '../../../Utility/Task/CardAnimationTask';
import { ICardStateTaskData } from '../../../State/Card/ICardState';
import BaseCard from '../../../Prototype/Level/Card/BaseCard';
import RockCard from '../../../Prototype/Level/Card/RockCard';
import { Anim } from '../../Animation/AnimationHelper';

export default function RockCardAnimation(
    system: CardSystem,
    taskData: ICardStateTaskData
): void {
    const targetCards: BaseCard[] = taskData.cards.map(cardID => system.getCardByID(cardID) as RockCard);
    system.taskQueue.queue(
        new CardAnimationTask(
            taskData,
            system,
            'CardRock',
            targetCards[0],
            {
                system: system,
                targetCards: targetCards,
            }
        )
    );
}
